export default __webpack_public_path__ + "static/media/time-import-button.427910c9.png";